var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnjoAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#4931C0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2198 13.2875C19.7403 10.9676 21.2322 8.69819 23.5521 8.21868C25.8721 7.73917 28.1414 9.23111 28.6209 11.551C29.1005 13.8709 27.6085 16.1403 25.2886 16.6198L21.088 17.4881L20.2198 13.2875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1749 23.9291C12.6954 21.6092 14.1873 19.3398 16.5072 18.8603L20.7078 17.992L21.576 22.1926C22.0555 24.5125 20.5636 26.7819 18.2437 27.2614C15.9238 27.7409 13.6544 26.249 13.1749 23.9291Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1992 22.1221C20.1992 22.1221 20.4017 18.0868 24.1896 16.0264L21.0636 14.1761C21.0636 14.1761 20.8804 17.9987 17.3817 19.8427L20.1992 22.1221Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4991 25.0892C25.0196 22.7693 26.5115 20.5 28.8314 20.0204C31.1514 19.5409 33.4207 21.0329 33.9002 23.3528C34.3798 25.6727 32.8878 27.9421 30.5679 28.4216L26.3673 29.2898L25.4991 25.0892Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4561 35.7348C17.9766 33.4148 19.4686 31.1455 21.7885 30.6659L25.989 29.7977L26.8573 33.9983C27.3368 36.3182 25.8448 38.5876 23.5249 39.0671C21.205 39.5466 18.9356 38.0547 18.4561 35.7348Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4766 33.9268C25.4766 33.9268 25.6791 29.8915 29.4669 27.831L26.3409 25.9807C26.3409 25.9807 26.1577 29.8034 22.6591 31.6474L25.4766 33.9268Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9805 25.1406C19.9805 25.1406 23.4707 23.103 27.281 25.1264L27.1095 21.5155C27.1095 21.5155 23.8079 23.4529 20.338 21.5518L19.9805 25.1406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnjoAvatar);
export default __webpack_public_path__ + "static/media/enjoAvatar.15d3bfed1530ebfe7b62b5c1153b15e6.svg";
export { ForwardRef as ReactComponent };